

<div class="grid grid-cols-1 md:grid-cols-2 grid-flow-row gap-1 md:gap-4 p-1 rounded-b-lg m-auto w-full md:w-11/12 py-4">
    <slot/>
</div>